import { CmsApplianceDetailsSteppedMultiPlanForm } from '../../models/appliance-details-stepped-multi-plan/cms-appliance-details-stepped-multi-plan-form.interface';

export const mockCmsApplianceDetailsSteppedMultiPlanForm: CmsApplianceDetailsSteppedMultiPlanForm =
  {
    applianceCodeField: {
      fieldLabel: 'Can you tell us what type of appliance it is?',
      fieldRequired: true,
    },
    applianceBuiltInCodeField: {
      fieldLabel: 'Is your appliance built in?',
      fieldRequired: true,
    },
    brandCodeField: {
      fieldLabel: 'What brand is your appliance?',
      fieldRequired: true,
    },
    extraAppliancesField: {
      fieldLabel: 'Add protection for all the appliances you rely on',
      fieldRequired: false,
    },
    purchasePriceField: {
      fieldLabel: 'How much did the appliance cost?',
      fieldHint: 'Approximately, how much did it cost?',
      fieldRequired: true,
    },
    purchaseDateField: {
      fieldLabel: 'When did you purchase it?',
      fieldHint: 'Select an approximate purchase date',
      fieldRequired: true,
    },
    warrantyField: {
      fieldLabel: 'Warranty',
      fieldHint: 'Select an approximate purchase date',
      fieldRequired: true,
    },
  };
